import _ from 'lodash'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { useMiniCart } from '../../hook/use-mini-cart'
import { useLink } from '../../hook/use-link'
import combineClassNames from '../../helpers/combineClassNames'
import SidePanel from '../side-panel'
import CartSelector from '../cart-selector'
import CartLineItem from '../cart-line-item'
import useStyles from './mini-cart-style'

const MiniCartView = () => {
  const {
    // cart,
    cartCurrency,
    cartLineItems,
    cartPriceSummary,
    loadings,
    miniCartOpen,
    // totalItems,
    // skusUnavailableToCheckout,
    closeMiniCart,
    // onCartChange,
    onUpdateCartLineQuantity,
    onAddCartLineToWaitlist,
    onRemoveCartLine,
  } = useMiniCart()
  const { navigate } = useLink()
  const { t } = useTranslation()
  // style
  const styles = useStyles()

  const buttons = [
    {
      text: t('ui.miniCart.buttons.viewCart'),
      className: combineClassNames([styles.button]),
      onClick: () => {
        closeMiniCart()
        navigate('/cart/')
      },
    },
  ]

  const cartLoading = _.includes(loadings, 'fetchCart')
  const loading = _.includes(loadings, 'updateCart')

  const panelProps = {
    buttons,
    isOpen: miniCartOpen,
    onRequestClose: closeMiniCart,
    title: t('ui.miniCart.title'),
    priceSummary: _.pick(cartPriceSummary, ['currencyCode', 'subtotal', 'quantityCount']),
  }

  const cartLineItemsWithoutWaitlist = _.reject(cartLineItems, 'cartLine.skuQuotaWaitingList')
  const waitlist = _.filter(cartLineItems, 'cartLine.skuQuotaWaitingList')

  return (
    <SidePanel
      {...panelProps}
    >
      <CartSelector
        className={styles.cartSelector}
      />
      <div className={styles.cartLines}>
        {
          cartLoading
            ? (
              <>
                {
                  _.times(3, (index) => (
                    <CartLineItem key={index} placeholder />
                  ))
                }
              </>
            )
            : (
              <>
                {
                  _.map(cartLineItemsWithoutWaitlist, ({
                    cartLine,
                    errors,
                    maxSelectableQty,
                    cartMaxNumOfQtyPerSku,
                    cartMaxAvailableNumOfQty,
                  }) => (
                    <CartLineItem
                      cartLine={cartLine}
                      cartMaxNumOfQtyPerSku={cartMaxNumOfQtyPerSku}
                      cartMaxAvailableNumOfQty={cartMaxAvailableNumOfQty}
                      currency={cartCurrency}
                      errors={errors}
                      // disableNavigation={enableQuickAddItem}
                      key={`product-${cartLine.id}`}
                      maxSelectableQty={maxSelectableQty}
                      // readOnly={isDineInOrderPlaced}
                      onEdit={closeMiniCart}
                      onRemove={onRemoveCartLine}
                      onUpdateQuantity={onUpdateCartLineQuantity}
                      onAddToWaitlist={onAddCartLineToWaitlist}
                      loading={loading}
                    />
                  ))
                }
                {
                  !_.isEmpty(waitlist) && (
                    <>
                      <h2
                        className={styles.sectionTitle}
                      >
                        {t('screens.cart.waitlistTitle')}
                      </h2>
                      {
                        _.map(waitlist, ({
                          cartLine,
                          errors,
                          maxSelectableQty,
                          cartMaxNumOfQtyPerSku,
                          cartMaxAvailableNumOfQty,
                        }) => (
                          <CartLineItem
                            cartLine={cartLine}
                            cartMaxNumOfQtyPerSku={cartMaxNumOfQtyPerSku}
                            cartMaxAvailableNumOfQty={cartMaxAvailableNumOfQty}
                            currency={cartCurrency}
                            errors={errors}
                            // disableNavigation={enableQuickAddItem}
                            key={`product-${cartLine.id}`}
                            maxSelectableQty={maxSelectableQty}
                            // readOnly={isDineInOrderPlaced}
                            onRemove={onRemoveCartLine}
                            onUpdateQuantity={onUpdateCartLineQuantity}
                            loading={loading}
                          // onEdit={
                          //   enableQuickAddItem
                          //     ? () => handleCartLineClick(cartLine)
                          //     : null
                          // }
                          />
                        ))
                      }
                    </>
                  )
                }
              </>
            )
        }
      </div>
    </SidePanel>
  )
}

export default MiniCartView
